<template>
  <div class="inventory">
    <div class="inventory-list">
      <div v-for="(rowArray, rowIndex) in itemArray" :key="rowIndex" class="inventory-row">
        <div v-for="(item, columnIndex) in rowArray" :key="columnIndex" class="inventory-cell"
             @click="selectedItem = item">
          <template v-if="item.id">
            <img :src="item.url" :title="item.name" class="inventory-image"/>
          </template>
          <template v-else>
            <div class="inventory-image"></div>
          </template>
        </div>
      </div>
    </div>
    <div class="item-info">
      <template v-if="selectedItem && selectedItem.id">
        <div class="item-info-row">
          <img :src="selectedItem.url" class="inventory-info-image"/>
          <h1 class="item-name">{{ selectedItem.name }}</h1>
          <div class="item-description">{{ selectedItem.description }}</div>
        </div>
        <div class="item-info-row actions" v-if="admin">
          <button class="use-item" type="button" @click="useItem">Использовать</button>
        </div>
      </template>
    </div>
  </div>
  <UseItemModal v-model:item-comment="useItemData.comment"
             v-model:item-name="useItemData.name"
             modal-id="use-item-modal"
             @close="() => vfm.close('use-item-modal')"
             @ok="useItemRequest"
  />
</template>

<script>
import ApiService from "@/services/api-service";
import UseItemModal from "@/components/UseItemModal";
import {useVfm} from "vue-final-modal";

export default {
  name: "InventoryList",
  components: {UseItemModal},
  data: function () {
    return {
      vfm: null,
      gridSize: 6,
      items: [],
      itemArray: [],
      selectedItem: null,
      useItemData:{
        itemId: null,
        name: null,
        comment: null
      },
    }
  },
  props: ["seasonNumber", "admin"],
  emits: ["itemUsed"],
  methods: {
    loadData(){
      ApiService.get(`rgg/season/${this.seasonNumber}/inventory-items`).then(response => {
        this.items = response.data.map(item => {
          try {
            item.url = require(`@/assets/img/items/${item.key}.png`)
          } catch {
            item.url = require(`@/assets/img/items/NoImage.png`)
          }

          return item
        })

        this.fillGrid()
      })
    },
    emptyItem() {
      return {
        id: null,
        itemId: null,
        name: null,
        description: null,
        url: null
      }
    },
    fillGrid() {
      this.itemArray = []
      for (let row = 0; row < this.gridSize; row++) {
        let rowArray = []
        for (let column = 0; column < this.gridSize; column++) {
          let columnItem = this.items[row * this.gridSize + column] ?? this.emptyItem()
          rowArray.push(columnItem)
        }
        this.itemArray.push(rowArray)
      }
    },
    useItem(){
      this.useItemData = {
        itemId: this.selectedItem.itemId,
        name: this.selectedItem.name,
        comment: null
      }

      this.vfm.open('use-item-modal')
    },
    useItemRequest(){
      ApiService.post("rgg/journal/item", {
        seasonNumber: this.seasonNumber,
        itemModel: {
          itemId: this.useItemData.itemId,
          actionType: "Used",
          comment: this.useItemData.comment
        }
      }).then(() => {
        this.selectedItem = null
        this.vfm.close('use-item-modal')
        this.loadData()
        this.$emit('itemUsed')
      })
    }
  },
  created(){
    this.vfm = useVfm()
  },
  mounted() {
    this.fillGrid()
    this.loadData()
  }
}
</script>

<style scoped>
.inventory {
  display: flex;
}

.inventory-list {
  flex: 0 0 540px;
}

.item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.inventory-row {
  display: flex;
}


.inventory-cell {
  cursor: pointer;
  background: #bbb;
  margin: 4px;
  padding: 6px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.inventory-cell:hover {
  padding: 2px;
}

.inventory-cell:hover .inventory-image {
  width: 72px;
  height: 72px;
}

.inventory-image {
  width: 64px;
  height: 64px;
}

.inventory-info-image {
  width: 128px;
  height: 128px;
  float: left;
  margin-right: 12px;
  margin-bottom: 12px;
}

.item-info .item-name {
  font-size: 28px;
  margin-bottom: 24px;
}

.item-info .item-description {
  font-size: 17px;
  line-height: 20px;
}

.item-info-row {
  align-content: center;
}

.item-info-row.actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.use-item {
  font-size: 1.1rem;
}

.use-item {
  border-color: #248b17;
  background-color: #006600;
}

.use-item:hover {
  border-color: #0b6800;
  background-color: #015401;
}


</style>